<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        @keydown.esc="cancel"
        :persistent="processing"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.customer.sendResearch.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>{{ $t('actions.customer.sendResearch.text') }}</p>

                <SearchModelInput
                    v-model="selectedResearch"
                    :model="research"
                    label="Pesquisa de satisfação"
                    item-text="name"
                />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click="close"
                    :disabled="processing"
                >
                    {{ $t('actions.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="perform"
                    :loading="processing"
                >
                    {{ $t('actions.customer.sendResearch.perform') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import SearchModelInput from '@/shared/inputs/SearchModelInput'
import Research from '@/models/Research'

export default {
    components: {
        SearchModelInput,
    },

    data() {
        return {
            dialog: false,
            customer: undefined,
            research: new Research(),
            processing: false,
            selectedResearch: null,
        }
    },

    watch: {
        dialog(value) {
            if (value) return
            this.customer = undefined
            this.selectedResearch = null
        },
    },

    methods: {
        open(customer) {
            this.dialog = true
            this.customer = customer
        },

        close() {
            this.dialog = false
        },

        async perform() {
            this.processing = true

            if (!this.selectedResearch) {
                this.processing = false
                return
            }

            let res = await this.research.send(
                this.selectedResearch,
                this.customer,
            )

            this.processing = false
            this.dialog = false

            if (!res) return

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.customer.sendResearch.success'),
            )
        },
    },
}
</script>

<style></style>
